(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cloudevents", [], factory);
	else if(typeof exports === 'object')
		exports["cloudevents"] = factory();
	else
		root["cloudevents"] = factory();
})(self, () => {
return 